import { SearchFilterOption } from "../../../shared/components/search-bar/search-filter/search-filter.component";
import { SearchInputOption } from "../../../shared/components/search-bar/search-input/search-input.component";
import { UserInfo } from "../../../shared/types/user-info";
import { PartnerService } from "../partners/partner.service";
import { Partner } from "../partners/partner.type";

//#region Search Filter Options

export const getCompanySearchFilterOptions = (
  user: UserInfo,
  config?: {
    shown?: string[];
    hidden?: string[];
    partnerService?: PartnerService;
  },
): SearchFilterOption<Partner>[] => {
  const { shown, hidden, partnerService } = config || {};

  return (
    [
      { value: "name", label: "Name" },
      { value: "companyIdentifier", label: "Company ID" },
      {
        value: "type",
        label: "Type",
      },
      {
        value: "status",
        label: "Status",
        inputType: "dropdown",
        options: [...companyStatuses],
        condition: "$eq",
      },
      {
        value: "partner.name",
        auxValue: "partnerId",
        label: "Partner",
        hidden: !user.isGlobal() || !partnerService,
        filterByProperty: { partner: { name: true } },
      },
    ] as SearchFilterOption<Partner>[]
  ).filter((opt) => (shown ? shown.includes(opt.value) : true) && (hidden ? !hidden.includes(opt.value) : true));
};

//#endregion

//#region Search Input Options

export const companyStatuses: SearchInputOption[] = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

//#endregion
